import * as NameSpace from 'src/store/NameSpace'
import { ParseService } from '../../Services/parse'
// import { getGoalAndDisplayDetails } from 'src/components/shared/helper/ViewKeyToServerKeyMapper'
// import { serverJsonToViewJson } from 'src/components/shared/helper/ServerOjectToViewObject'
import { FlexTable } from 'src/components/shared/flexTables'

const state = {
  [NameSpace.STATE_GOALS_AND_DISPLAY]: {
    value: [],
    error: null
  },
  [NameSpace.STATE_APPROVE_OFFER_SUCCESS]: {
    result: null,
    success: false
  }
}

const getters = {
  [NameSpace.GET_GOALS_AND_DISPLAY]: state => {
    return state[NameSpace.STATE_GOALS_AND_DISPLAY]
  },
  [NameSpace.GET_APPROVE_OFFER_SUCCESS]: state => {
    return state[NameSpace.STATE_APPROVE_OFFER_SUCCESS]
  }
}

const mutations = {
  [NameSpace.MUTATE_GOALS_AND_DISPLAY]: (state, payload) => {
    state[NameSpace.STATE_GOALS_AND_DISPLAY] = payload
  },
  [NameSpace.MUTATE_APPROVE_OFFER_SUCCESS]: (state, payload) => {
    state[NameSpace.STATE_APPROVE_OFFER_SUCCESS] = payload
  }
}

const actions = {
  [NameSpace.ACTION_GOALS_AND_DISPLAY]: ({ commit }, payload) => {
    ParseService.getApproveOffers(payload)
      .then(goalsAndDisplay => {
        console.log(goalsAndDisplay)
        // let data = serverJsonToViewJson(goalsAndDisplay, getGoalAndDisplayDetails)
        if (goalsAndDisplay) {
          commit(NameSpace.MUTATE_GOALS_AND_DISPLAY, {value: goalsAndDisplay, error: null})
        } else {
          commit(NameSpace.MUTATE_GOALS_AND_DISPLAY, {value: [], error: null})
        }
      })
      .catch(error => {
        console.log('In goalsAndDisplay js getApproveOffers:', error)
        commit(NameSpace.MUTATE_GOALS_AND_DISPLAY, {value: [], error: error})
      })
  },
  [NameSpace.ACTION_APPROVE_OFFER]: ({ commit, state }, payload) => {
    ParseService.approveOffer(payload)
      .then(approveOffersResult => {
        if (approveOffersResult) {
          // rootState.zonePriceEdit['STATE_ZONE_SALE_PRICES'] = setUpZonePriceData(approveOffersResult)
          // self.$set(rootState.zonePriceEdit, 'STATE_ZONE_SALE_PRICES', setUpZonePriceData(approveOffersResult))
          // console.log('rootState.zonePriceEdit[STATE_ZONE_SALE_PRICES]', rootState.zonePriceEdit)
          commit(NameSpace.MUTATE_APPROVE_OFFER_SUCCESS, {result: setUpZonePriceData(approveOffersResult), success: true})
        } else {
          commit(NameSpace.MUTATE_APPROVE_OFFER_SUCCESS, {result: approveOffersResult, success: false})
        }
        // setTimeout(() => {
        //   commit(NameSpace.MUTATE_GOALS_AND_DISPLAY, {
        //     result: null,
        //     success: false
        //   })
        // }, 0)
      })
      .catch(error => {
        console.log('In goalsAndDisplay js approveOffer:', error)
        commit(NameSpace.MUTATE_APPROVE_OFFER_SUCCESS, {
          result: (typeof err === 'object') ? error.message : error,
          success: false
        })
        setTimeout(() => {
          commit(NameSpace.MUTATE_GOALS_AND_DISPLAY, {
            result: null,
            success: false
          })
        }, 0)
      })
  }
}

function setUpZonePriceData (approveResult) {
  let tableInstance = new FlexTable(approveResult.header, approveResult.data, 0)
  const resultHeader = tableInstance.getObjectTableHeaders(approveResult.header, 'Zone Id')
  let tableHeadersString = tableInstance.getStringTableHeaders(approveResult.header)
  const editableHeader = tableInstance.getIndexforFillteredTableHeaders(approveResult.header, 'makeEditable')
  const tableData = tableInstance.getCellDataAsObject(tableHeadersString, approveResult.data, 'makeEditable', 'set_zone', 100, editableHeader)
  for (let array of tableData) {
    array.splice(0, 1)
  }
  let result = {
    headers: resultHeader,
    data: tableData,
    success: true,
    error: null,
    showAgain: true
  }
  return result
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/goalsAndDisplay.js